export function clone(hierarchy: Hierarchy.IHierarchyItem[], filter?: (item: Hierarchy.IHierarchyItem) => boolean, trim: boolean = true) : Hierarchy.IHierarchyItem[] {

    const result: Hierarchy.IHierarchyItem[] = [];

    const walk = (parent: Hierarchy.IHierarchyItem, items: Hierarchy.IHierarchyItem[]) => {
        if (!items) {
            return;
        }

        items.forEach(item => {
            const copy = { ...item };

            if (filter) {
                if (!filter(copy)) {
                    return;
                }
            }

            copy.parent = parent;

            copy.children = [];

            if (parent) {
                parent.children.push(copy);
            }

            if (!copy.parent) {
                result.push(copy);
            }

            walk(copy, item.children);

            const noChildren = !copy.children || !copy.children.length;

            if (trim && noChildren && !copy.isWell && copy.parent) {
                copy.parent.children = copy.parent.children.filter(x => x !== copy);
            }
        });
    };

    walk(null, hierarchy);

    return result;
}
